import { inject } from '@angular/core';
import type { DefaultContext, TypedDocumentNode } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { map, type Observable } from 'rxjs';
import type { DataTableData } from '../../../components/data-table/types';
import type { FetchVariables } from './types';

/**
 * static-graphql-documents (D3 clean break): no `fields?` parameter anymore
 * — see `query-find.ts` for the rationale. Unlike the other three fetchers,
 * `queryPaginate` KEEPS an explicit caller-supplied `<T>` for the row item
 * type: `paginationQuery` carries no fragment (its `rows` field is an
 * untyped JSON scalar with no subselection, see design.md D1 non-goal), so
 * there is nothing in the document itself to infer the row type FROM.
 */
export function queryPaginate<T>(
  statement: TypedDocumentNode<Record<string, unknown>, FetchVariables>,
  key: string,
  variables?: FetchVariables,
): Observable<DataTableData<T>> {
  const apollo = inject(Apollo);

  return apollo
    .query<Record<string, DataTableData<T>>>({
      query: statement,
      variables,
      context: { headers: variables?.headers } as DefaultContext,
    })
    .pipe(map((result) => result.data?.[key] ?? { count: 0, total: 0, rows: [] }));
}
